/**
 * Helpers compartidos para armar el payload de `calculo/cast_conditions`
 * (grafica-modelo y multicharts-dialog).
 */

/**
 * `ln` del modelo (tuplas [texto, tipo, meta]) → condiciones legibles separadas en
 * entrada y salida, para mostrarlas sobre el chart.
 */
export function splitCondicionLegible(ln: any[] | undefined): { entrada: string[]; salida: string[] } {
  const pares: [string, string][] = Array.isArray(ln) ? ln.map((x: any) => [x[0], x[1]]) : [];
  return {
    entrada: pares.filter(([, tipo]) => tipo === 'Entrada').map(([texto]) => texto),
    salida: pares.filter(([, tipo]) => tipo === 'Salida').map(([texto]) => texto),
  };
}

/**
 * cast_conditions solo pinta columnas de las condiciones de entrada: se manda la
 * condición del modelo como dsl más las de salida, todo en `list_conditions_entry`.
 */
export function castEntryConditions(condicion: string | null | undefined, exits: any[] | undefined): any[] {
  return [
    ...(condicion ? [{ dsl: condicion }] : []),
    ...(exits ?? []),
  ];
}
